import { commonService } from '.';

const getAllLevel = (body) => {
    return commonService.getWithParam('Language/levels', body);
};

const addLanguage = (body) => {
    return commonService.post('Language/add', body);
};

const getLanguageByDc = (body) => {
    return commonService.getWithParam('Language/getByDc', body);
};

const deleteLanguage = (id, idDc, idLang) => {
    return commonService.deleteWithParam('Language?id=' + id + '&idDc=' + idDc + '&idLang=' + idLang, null);
};

const updateLanguage = (body) => {
    return commonService.put('Language/update', body);
};

export const languageService = {
    getAllLevel,
    addLanguage,
    getLanguageByDc,
    deleteLanguage,
    updateLanguage
};
